import { UserBackendModel } from '../../backend/auth/model/user-backend.model';

export interface AuthSessionStateInterface {
  activeUser: UserBackendModel;
}

export const initAuthSessionStateInterface: AuthSessionStateInterface = {
  activeUser: null,
};
